import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import {
    headers, getPromoCodeDetailsUrl, insertPromoCodeUrl, getPromoCodeListUrl, deletePromoCodeUrl, updatePromoCodeUrl,
    updateRightsMasterUrl, GET_PROMOCODE_LIST, getRightsMasterListUrl,
    INSERT_PROMOCODE,
    UPDATE_PROMOCODE,
    DELETE_PROMOCODE,
    GET_PROMOCODE_DETAILS
} from "../../../../utils/constants";

export const getRightsMasterList_action = (ExhibitionID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getRightsMasterListUrl, params, headers)

        dispatch({
            type: GET_PROMOCODE_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateRightsMaster_action = (ExihibitionID, moduleList) => async (dispatch) => {
    try {
        const params = {
            // UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID,
            moduleList: moduleList,

        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(updateRightsMasterUrl, params, headers)

        dispatch({
            type: UPDATE_PROMOCODE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}
